import { HTMLAttributes, PropsWithChildren } from "react";
import clsx from "clsx";

interface Props extends PropsWithChildren<HTMLAttributes<HTMLButtonElement>> {
  variant?: "contained" | "outlined";
  color?: "primary";
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

export default function Button(props: Props) {
  const {
    variant = "contained",
    color = "primary",
    className,
    children,
    disabled,
    type = "button",
    ...rest
  } = props;
  return (
    <button
      type={type}
      className={clsx(
        "inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-2.5 font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        {
          "bg-primary text-white hover:bg-primaryDark":
            variant === "contained" && color === "primary",
          "border-2 border-primary bg-transparent text-primary hover:bg-primaryLight":
            variant === "outlined" && color === "primary",
        },
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}
